<template>
  <div v-if="ready" :class="$style.container">
    <ol v-if="activities.length">
      <li v-for="activity in activities" :key="activity.id">
        <CallInfo
          :activity="activity"
          :info="[]"
          :actions="['summarize', 'take-notes', 'play']"
          :class="$style.callInfo" />
      </li>
    </ol>
    <p v-else :class="$style.noTasks">There are no tasks to do 🎉</p>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/lib/store'
import { jiminnyHost } from '@/helpers/region'
import CallInfo from '@/components/shared/CallInfo/CallInfo'

export default {
  components: {
    CallInfo
  },
  data () {
    return {
      user: store.get('user'),
      activities: [],
      ready: false
    }
  },
  mounted () {
    this.retrieveActivities()
  },
  methods: {
    async retrieveActivities () {
      try {
        const response = await axios.get(`${jiminnyHost()}/api/v1/activity/search`, {
          params: {
            'user_id': [this.user.id],
            'sort_by': 'dateHeld',
            'sort_direction': 'desc',
            'exclude': ['stats'],
            'min_duration': '0',
            'not_logged': '1',
            'sequence_number': '1',
            'status': ['completed', 'canceled']
          }
        })

        this.activities = response.data.results
        this.ready = true
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style module lang="less" src="./Tasks.less"></style>



// WEBPACK FOOTER //
// Tasks.vue?055a9a85